<!-- file-preview-overlay-toolbar.component.html -->
<div class="toolbar-wrapper">
    <ng-content></ng-content>
</div>